import React, { FC } from "react";
import cx from "classnames";
import Tooltip, { TooltipProps } from "../Tooltip";
import "./styles.scss";

export enum QuestionTooltipVariant {
  primary = "primary",
  secondary = "secondary",
}

export enum QuestionTooltipSize {
  medium = "medium",
  small = "small",
  tiny = "tiny",
}

export interface QuestionTooltipProps extends TooltipProps {
  variant?: QuestionTooltipVariant;
  size?: QuestionTooltipSize;
}

const QuestionTooltip: FC<React.PropsWithChildren<QuestionTooltipProps>> = ({
  size,
  variant = QuestionTooltipVariant.primary,
  ...tooltipProps
}) => {
  const questionMarkClass = cx("question-tooltip__question-mark", {
    primary: variant === QuestionTooltipVariant.primary,
    secondary: variant === QuestionTooltipVariant.secondary,
  });

  return (
    <Tooltip {...tooltipProps}>
      <button
        type="button"
        className={cx("question-tooltip", {
          medium: size === QuestionTooltipSize.medium,
          tiny: size === QuestionTooltipSize.tiny,
        })}
      >
        <div className={questionMarkClass}>?</div>
      </button>
    </Tooltip>
  );
};

export default QuestionTooltip;
